import defaultClient from '@src/api/clients/default';

export function fetchClientCreativeKnowledge(params = {}) {
  return defaultClient.request({
    url: 'dashboard/client-creative-knowledge/',
    method: 'GET',
    payload: params,
  });
}

export function createClientCreativeKnowledge(payload) {
  return defaultClient.request({
    url: 'dashboard/client-creative-knowledge/',
    method: 'POST',
    payload,
  });
}

export function updateClientCreativeKnowledge(id, payload) {
  return defaultClient.request({
    url: `dashboard/client-creative-knowledge/${id}/`,
    method: 'PATCH',
    payload,
  });
}

export function deleteClientCreativeKnowledge(id) {
  return defaultClient.request({
    url: `dashboard/client-creative-knowledge/${id}/`,
    method: 'DELETE',
  });
}

export function fetchSharedVerticalCreativeAssets(verticalIds = []) {
  return defaultClient.request({
    url: 'dashboard/client-creative-knowledge/shared-vertical-assets/',
    method: 'GET',
    payload: { vertical_ids: verticalIds.join(',') },
  });
}

// One-shot Claude extraction of proof slots (warranty / experience /
// certifications / install_quality) from this row's notes +
// ai_script_instructions. ~$0.005 per call. Backend persists + returns the
// updated KB row.
export function autoFillCreativeKnowledgeProofs(id) {
  return defaultClient.request({
    url: `dashboard/client-creative-knowledge/${id}/auto-fill-proofs/`,
    method: 'POST',
    payload: {},
  });
}
